/**
 * IONLOOP Assistant — safe structured-answer renderer.
 *
 * Renders the structured answer object into DOM elements using textContent
 * only. Never uses innerHTML for user or knowledge content; no scripts can
 * execute.
 */

function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) {
        node.className = className;
    }
    if (text !== undefined && text !== null) {
        node.textContent = text;
    }
    return node;
}

function makeTitle(answer) {
    if (!answer.title) {
        return null;
    }
    var h = el('h3', 'ili-answer__title', answer.title);
    return h;
}

function makeIntro(answer) {
    if (!answer.intro) {
        return null;
    }
    return el('p', 'ili-answer__intro', answer.intro);
}

function makeParagraphs(answer) {
    var nodes = [];
    (answer.paragraphs || []).forEach(function (text) {
        if (text) {
            nodes.push(el('p', 'ili-answer__para', text));
        }
    });
    return nodes;
}

function makeBullets(answer) {
    if (!answer.bullets || answer.bullets.length === 0) {
        return [];
    }
    var ul = el('ul', 'ili-answer__bullets');
    answer.bullets.forEach(function (text) {
        if (text) {
            ul.appendChild(el('li', 'ili-answer__bullet', text));
        }
    });
    return [ul];
}

function makeSteps(answer) {
    if (!answer.steps || answer.steps.length === 0) {
        return [];
    }
    var ol = el('ol', 'ili-answer__steps');
    answer.steps.forEach(function (text) {
        if (text) {
            ol.appendChild(el('li', 'ili-answer__step', text));
        }
    });
    return [ol];
}

function makeActions(answer) {
    if (!answer.actions || answer.actions.length === 0) {
        return [];
    }
    var wrap = el('div', 'ili-answer__actions');
    (answer.actions || []).forEach(function (action) {
        var a = el('a', 'ili-answer__action', action.label);
        a.href = action.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        wrap.appendChild(a);
    });
    return [wrap];
}

function makeSources(answer) {
    if (!answer.sources || answer.sources.length === 0) {
        return [];
    }
    var wrap = el('div', 'ili-answer__sources');
    wrap.appendChild(el('p', 'ili-answer__sources-label', 'Sources'));
    var ul = el('ul', 'ili-answer__sources-list');
    (answer.sources || []).forEach(function (source) {
        var li = el('li', 'ili-answer__source');
        var a = el('a', 'ili-answer__source-link', source.title);
        a.href = source.url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        li.appendChild(a);
        ul.appendChild(li);
    });
    wrap.appendChild(ul);
    return [wrap];
}

function makeSuggestions(answer) {
    var suggestions = answer.suggestions || (answer.bullets || []);
    if (!suggestions.length) {
        return [];
    }
    var wrap = el('div', 'ili-answer__suggestions');
    var ul = el('ul', 'ili-answer__suggestions-list');
    suggestions.forEach(function (text) {
        if (typeof text !== 'string' || !text.trim()) {
            return;
        }
        var button = el('button', 'ili-answer__suggestion', text);
        button.type = 'button';
        button.setAttribute('data-ili-suggestion', text);
        var li = el('li', 'ili-answer__suggestion-item');
        li.appendChild(button);
        ul.appendChild(li);
    });
    wrap.appendChild(ul);
    return [wrap];
}

function makeFollowUps(answer) {
    if (!answer.followUps || answer.followUps.length === 0) {
        return [];
    }
    var wrap = el('div', 'ili-answer__followups');
    wrap.appendChild(el('p', 'ili-answer__followups-label', 'You may also ask:'));
    var ul = el('ul', 'ili-answer__followups-list');
    (answer.followUps || []).forEach(function (text) {
        if (typeof text !== 'string' || !text.trim()) {
            return;
        }
        var button = el('button', 'ili-answer__followup', text);
        button.type = 'button';
        button.setAttribute('data-ili-followup', text);
        var li = el('li', 'ili-answer__followup-item');
        li.appendChild(button);
        ul.appendChild(li);
    });
    wrap.appendChild(ul);
    return [wrap];
}

function makeCommandTopics(answer) {
    if (!answer.categories || !answer.categories.length) {
        return [];
    }
    var wrap = el('div', 'ili-answer__topics');
    wrap.appendChild(el('p', 'ili-answer__sources-label', 'Knowledge areas'));
    var list = el('ul', 'ili-answer__topics-list');
    (answer.categories || []).forEach(function (cat) {
        var li = el('li', 'ili-answer__topic-item');
        var button = el('button', 'ili-answer__topic', cat.label + (cat.count ? ' (' + cat.count + ')' : ''));
        button.type = 'button';
        button.setAttribute('data-ili-category', cat.key);
        li.appendChild(button);
        list.appendChild(li);
    });
    wrap.appendChild(list);
    return [wrap];
}

/**
 * Render a structured answer into a container element.
 * @returns {HTMLElement} the container with all answer nodes appended.
 */
function renderAnswer(container, answer) {
    if (!container || !answer) {
        return container;
    }
    var sections = [makeTitle, makeIntro, makeParagraphs, makeBullets, makeSteps, makeCommandTopics, makeActions, makeSources, makeSuggestions, makeFollowUps];
    sections.forEach(function (fn) {
        var nodes = fn(answer);
        if (nodes === null || nodes === undefined) {
            return;
        }
        if (!Array.isArray(nodes)) {
            nodes = [nodes];
        }
        nodes.forEach(function (node) {
            if (node) {
                container.appendChild(node);
            }
        });
    });
    return container;
}

module.exports = {
    renderAnswer: renderAnswer,
    makeTitle: makeTitle,
    makeIntro: makeIntro,
    makeParagraphs: makeParagraphs,
    makeBullets: makeBullets,
    makeSteps: makeSteps,
    makeActions: makeActions,
    makeSources: makeSources,
    makeSuggestions: makeSuggestions,
    makeFollowUps: makeFollowUps
};
